/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$info-icon-default-shadow: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  box-sizing: border-box;
  display: flex;
}

:host,
[type="button"],
[type="reset"],
[type="submit"] {
  @include button-reset-appearance;
}

:host([disabled]:not([disabled="false"])) {
  pointer-events: none;
  button {
    opacity: 0.6;
  }
}

button {
  @include button-reset;
  font-family: $font-family-base;
  cursor: pointer;

  // for Edge V18
  &:hover {
    text-decoration: none;
    box-shadow: $info-icon-default-shadow;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &:focus-visible {
    border-radius: 2px;
    @include focusBorder(v(iconFocusColor), 6px);
    box-shadow: $info-icon-default-shadow;

    &.#{$prefix}small {
      outline-offset: 2px;
    }
  }

  &:hover {
    eon-ui-icon {
      color: v(iconHoverColor);
    }
  }

  /* &.#{$prefix}visibility-onClick {
    cursor: pointer;
  } */
}

eon-ui-icon {
  color: v(iconColor);
  fill: currentColor;
}
